import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetLastOperation = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_ID_REPORT_GAMES
            });

            if (data.status === 'success') {
                const events = [...getState().usersMobile.last_operation.data];
                for (let i = 0; i < data.data.length; i = i + 2) {
                    const event_win = data.data[i];
                    const event_bet = data.data[i + 1];

                    const temp = {
                        date_event: event_win.date_event,
                        game_name: event_win.game_name,
                        amount_win: event_win.amount,
                        amount_bet: event_bet.amount,
                        balance_after: event_win.balance_after,
                        balance_before: event_bet.balance_before,
                        game_uuid: event_bet.game_uuid
                    }
                    events.push(temp)
                }
                dispatch(Action.SetGetLastOperationAction({
                    data: events.flat(1),
                    count: data.count,
                    countPage: data.allPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetLastOperation as SetGetLastOperation
}